import { Table, Input, Button, Grid } from "antd";
import React, { useEffect, useState } from "react";
import { useQuery } from "react-query";
import { fetchGeneric } from "../../services/api";
import { PageHeader } from "@ant-design/pro-components";

const { Search } = Input;
const { useBreakpoint } = Grid;

const CustomTable = ({
  columns,
  url,
  title = "",
  onCancel,
  editForm,
  createForm,
  edit,
  children,
  rowSelection,
}) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [page, setPage] = React.useState(1);
  const [pageSize, setPageSize] = React.useState(10);
  const [filterText, setFilterText] = React.useState("");
  const [sorter, setSorter] = React.useState({ sort: "id", direction: "desc" });
  const [editId, setEditId] = useState(null);
  const [createVisible, setCreateVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);

  const [filters, setFilters] = useState({});

  const onSearch = (value) => {
    setFilterText(value);
    setPage(1);
  };

  useEffect(() => {
    setEditId(edit);
    if (edit) {
      setEditVisible(true);
    }
  }, [edit]);

  const onCancelOrClose = () => {
    setCreateVisible(false);
    setEditVisible(false);
    if (onCancel) onCancel();
  };
  const { isLoading, data, refetch } = useQuery(
    ["companies", url, page, filterText, filters, sorter],
    () =>
      fetchGeneric(url, { page, filterText, ...sorter, ...filters, pageSize }),
    { keepPreviousData: false }
  );

  const handleTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);

    setPageSize(pagination.pageSize);

    setSorter({
      sort: sorter.columnKey,
      direction:
        sorter.order === "ascend"
          ? "asc"
          : sorter.order === "descend"
          ? "desc"
          : "",
    });
  };

  const EditForm = editForm;
  const CreateForm = createForm;

  const applyFilter = (newFilters) => {
    setFilters({ ...filters, ...newFilters });
  };

  const resetFilters = () => {
    setFilters({});
  };

  const activeFilterCount = Object.values(filters).filter(
    (value) => value !== undefined && value !== null && value !== "",
  ).length;

  return (
    <div className="custom-table-shell">
      <PageHeader className="custom-table-header" title={title} />

      <div className="custom-table-toolbar">
        <div className="custom-table-search">
          <Search
            allowClear
            placeholder="Buscar..."
            onSearch={onSearch}
          />
          {activeFilterCount > 0 && (
            <Button size="small" type="link" onClick={resetFilters}>
              {activeFilterCount} filtro{activeFilterCount > 1 ? "s" : ""} activo
              {activeFilterCount > 1 ? "s" : ""}
            </Button>
          )}
        </div>

        <div className="custom-table-actions">
          {createForm && typeof createForm == "function" && (
            <Button
              onClick={() => setCreateVisible(!createVisible)}
              type="default"
            >
              + Nuevo registro
            </Button>
          )}

          {typeof children == "function"
            ? children({ filterText, page, filters, applyFilter, resetFilters })
            : children}
        </div>

        {createForm && typeof createForm == "function" && (
          <CreateForm
            total={data?.meta.total}
            onSuccess={refetch}
            onCancel={onCancelOrClose}
            title="Nuevo registro"
            visible={createVisible}
            method="POST"
          />
        )}

        {editForm && typeof editForm == "function" && (
          <EditForm
            edit={editId}
            onSuccess={refetch}
            onCancel={onCancelOrClose}
            title="Editar registro"
            visible={editVisible}
            method="PATCH"
          />
        )}
      </div>

      <Table
        className="custom-table"
        rowSelection={rowSelection}
        size="small"
        rowKey={(record) => record.id}
        onChange={handleTableChange}
        pagination={{
          size: "default",
          pageSize: pageSize,
          current: page,
          total: data?.meta.total,
          pageSizeOptions: [10, 20, 50, 100, 500],
          showSizeChanger: !isMobile,
          showLessItems: isMobile,
          responsive: true,
          showTotal: isMobile
            ? undefined
            : (total, range) => `${range[0]}-${range[1]} de ${total}`,
        }}
        loading={isLoading}
        dataSource={data?.data}
        columns={columns}
        scroll={{ x: "max-content" }}
      />
    </div>
  );
};

export default CustomTable;
